import { GET_CRM_DATA } from "../../shared/constants/ActionTypes";

const initialState = {
  crmData: {},
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CRM_DATA:
      return {
        ...state,
        crmData: action.payload,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
